
module Meevo.Components.Controls {

    import MeevoMessengerMessage = Meevo.Plugins.MeevoMessenger.MeevoMessengerMessage;

    interface IMessageBubbleComponentScope extends ng.IScope {
    }

    enum MessageStatus {
        Delivered,
        Sending,
        Failed,
        OptedOut
    }

    class MeevoMessageBubbleComponent implements ng.IComponentController {

        static $inject = [
            '$scope',
            'meevo.components.modal.ModalService'
        ];

        public message: MeevoMessengerMessage;
        public replyMessageBubbleColor: string;
        public incomingMessageBubbleColor: string;
        public timeZoneOffset: string;
        public onImageExpand: Function;
        public defaultIncomingMessageColor = '#ffffff';
        public defaultReplyMessageColor = '#d4ebf9';
        constructor(
            private $scope: IMessageBubbleComponentScope,
            private modalService: Meevo.Components.Modal.IModalService
        ) { }

        $onInit() {

            if (!this.replyMessageBubbleColor) {
                this.replyMessageBubbleColor = this.defaultReplyMessageColor;
            };

            if (!this.incomingMessageBubbleColor) {
                this.incomingMessageBubbleColor = this.defaultIncomingMessageColor;
            };
        }

        getImgSrc(attachmentInfo: Meevo.Model.IMeevoMessengerAttachmentItem) {
            return `data:${attachmentInfo.mimeType};base64,${attachmentInfo.attachment}`;
        }

        expandImage($event) {
            if (_.isFunction(this.onImageExpand)) {
                this.onImageExpand({ imgSrc: $event.target.src });
            }
        }

        getMessageDataStatus(status: MessageStatus) {
            let messageData = {
                color: this.defaultIncomingMessageColor,
                label: ''
            }
            switch (status) {
                case MessageStatus.Sending:
                    messageData.color = "#808080"
                    messageData.label = 'Sending'
                    break;
                case MessageStatus.Delivered:
                    messageData.color = "#808080"
                    messageData.label = 'Delivered'
                    break;
                case MessageStatus.Failed:
                    messageData.color = "#FF0000"
                    messageData.label = 'Failed'
                    break;
                case MessageStatus.OptedOut:
                    messageData.color = "#FF0000"
                    messageData.label = 'Opted-Out'
                    break;
                default:
                    break;
            }

            return messageData
        }

        get convertedTime() {
            let timeOffset = this.timeZoneOffset.substring(0, this.timeZoneOffset.indexOf(':'));
            if (this.message && this.message.createdDateTime) {
                return moment(this.message.createdDateTime).add(timeOffset, 'hours').format();
            }
            return ''
        }

        get tailRightBorderColor() {
            return { 'border-color': `transparent transparent transparent ${this.replyMessageBubbleColor}` };
        }

        get tailLeftBorderColor() {
            return { 'border-color': `transparent ${this.incomingMessageBubbleColor} transparent transparent` };
        }


    }

    angular.module('meevo.components.controls')
        .component('meevoMessageBubbleComponent', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/message-bubble/message-bubble.component.html',
            controller: MeevoMessageBubbleComponent,
            controllerAs: '$ctrl',
            bindings: {
                message: '<',
                incomingMessageBubbleColor: '<?',
                replyMessageBubbleColor: '<?',
                onImageExpand: '&?',
                timeZoneOffset: '<',
                showStatus: '<?'
            },
            transclude: {
                editTransfer: '?messageSelect',
            }
        });
}
